module.exports = __webpack_public_path__ + "img/store.d35cb667.png";